import { Link } from "react-router-dom";

/**
 * A single notification row in the drop-alerts panel. Renders the message,
 * timestamp, and highlights unread items with an ember bar on the left.
 */
export default function NotificationItem({ n, onClick }) {
  const to = n.kind === "album"
    ? `/album/${n.item_id}`
    : n.artist_id ? `/artist/${n.artist_id}` : "/";

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`block px-4 py-3 hover:bg-white/[0.03] transition-colors ${
        !n.read ? "border-l-2 border-[#FF4500]" : ""
      }`}
    >
      <div className="font-mono text-xs text-white">{n.message}</div>
      <div className="font-mono text-[9px] uppercase tracking-widest text-gray-500 mt-1">
        {new Date(n.created_at).toLocaleString()}
      </div>
    </Link>
  );
}
